<template>
  <div :class="{'container h-100 d-flex justify-content-center': !loaded || (loaded && error)}">
    <div :class="{'nav-open': $sidebar.showSidebar}" v-if="loaded && !error">
      <notifications transition-name="notification-list" transition-mode="out-in">
      </notifications>
      <router-view name="header"></router-view>
      <transition name="fade"
                  mode="out-in">
        <router-view></router-view>
      </transition>
      <router-view name="footer"></router-view>
    </div>
    <div class="jumbotron my-auto app-loading" v-if="!loaded || (loaded && error)">
      <img class="mb-2" :src="$store.state.logoFull"  :alt="$store.state.site_name">
      <div v-if="!error">
      <b-spinner label="Loading..." style="width: 6rem; height: 6rem; margin: 0 auto; display: block"></b-spinner>
      <h2 class="text-center mt-4">{{$t('global.appLoading')}}</h2>
      </div>
      <div v-else>
        <h2 class="text-center mt-4 mb-2">{{$t('global.appLoadingError')}}</h2>
        <h5  class="text-center mt-0">{{$t('global.appLoadingErrorText')}}</h5>
      </div>
      <small class="text-right">
        © Coded by
        <a target="_blank" rel="noopener" href="http://exentis.pl">
          Exentis
        </a>
        .
      </small>
    </div>
  </div>
</template>

<script>
// Loading some plugin css asynchronously
import 'sweetalert2/dist/sweetalert2.css'
import 'vue-notifyjs/themes/default.css'
import axios from 'axios'
import { version } from '../package.json'

export default {
  components: {
    // Loader
  },
  data () {
    return {
      loaded: false,
      error: false
    }
  },
  created () {
    this.fetchConfiguration()
  },
  methods: {
    fetchConfiguration () {
      axios
        .get('api/configuration')
        .then(response => {
          this.loaded = true
          this.$store.commit('configuration/setConfiguration', response.data['hydra:member'][0])
          if (version !== this.$store.getters['configuration/version']) {
            alert('Została zainstalowana nowa wersja serwisu, prosimy o odświeżenie przeglądarki poprzez równoczesne wciśnięcie klawiszy Ctrl+F5. Dziękujemy i przepraszamy za utrudnienia')
          }
        })
        .catch(error => {
          this.error = true
          console.log(error)
        })
    }
  }
}
</script>
<style>

</style>
